// @flow
import styled, { css } from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import { px, mb } from 'styled-components-spacing';
import Grid from 'styled-components-grid';

export const sectionSpacing = css`
  ${mb(5)}
  ${breakpoint('desktop')`
    margin-bottom: 160px;
  `}
`;

export const sectionSpacingSmall = css`
  ${mb(5)}
  ${breakpoint('desktop')`
    margin-bottom: 140px;
  `}
`;

export const maxWidthStyle = css`
  max-width: 1200px;
`;

export const StyledCoverMaxWidth = styled.div`
  ${maxWidthStyle};
  margin: 0 auto;
  position: relative;
  ${sectionSpacing}
  ${breakpoint('desktop')`
    ${px(3)}
  `}
`;

export const StyledCoverMaxWidthNoBottomMargin = styled.div`
  ${maxWidthStyle};
  margin: 0 auto;
  position: relative;
`;

export const StyledCoverMaxWidthPadding = styled(StyledCoverMaxWidth)`
  ${px(3)}
`;

export const StyledCoverCenter = styled.div`
  display: flex;
  justify-content: center;
`;

export const maxWidthWideStyle = css`
  max-width: 1680px;
`;

export const StyledVerticalSpacer = styled(Grid)`
  margin-bottom: 3rem;
  display: flex;
  flex-direction: column;
  ${({ flexrow }) => flexrow && 'flex-direction: column'};
  ${breakpoint('mobile', 'tablet')`
  margin-bottom: 1rem;
 `}
  ${breakpoint('tablet', 'desktop')`
  margin-bottom: 2rem;
 `}
`;

export const StyledMiniVerticalSpacer = styled(StyledVerticalSpacer)`
  margin-bottom: 2rem;
  ${breakpoint('mobile', 'tablet')`
  margin-bottom: 1rem;
 `}
`;

export const StyledPageCover = styled.div`
  width: calc(100% - 4rem);
  padding: 2rem;
  background: ${({ bgcolor }) => bgcolor || 'white'};
  padding-bottom: 0px;
  padding-top: 0px;
  .lazy-load-image-background.blur.lazy-load-image-loaded {
    display: inline !important;
  }

  ${breakpoint('mobile', 'desktop')`
   padding: 1rem;
   width: calc(100% - 2rem);
   padding-bottom: 0px;
  padding-top: 0px;
  `}
`;

export const Spacer = styled.div`
  display: flex;
  width: 100%;
  padding: 2rem 0px;
`;

export const StyledFormUnit = styled(Grid.Unit)`
  ${({ even }) => (even ? 'padding-left: 10px' : 'padding-right: 10px')};
  ${breakpoint('mobile', 'tablet')`
      ${({ even }) => (even ? 'padding-left: 10px' : 'padding-right: 10px')};
  `}
`;
